var _defs, _rect, _rect2, _rect3, _rect4, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 560,
    height: 960,
    viewBox: "0 0 560 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "frame",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d9d3c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c8c1b4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "door",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ece7dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#e5dfd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d9d2c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fffef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f0ebdf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tape",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f6e8a9",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d6bf6b",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("filter", {
    id: "paperShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 5,
    floodColor: "#000000",
    floodOpacity: 0.18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 960,
    fill: "url(#frame)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 0,
    width: 30,
    height: 960,
    fill: "url(#frame)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 560,
    height: 30,
    fill: "url(#frame)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 500,
    height: 930,
    rx: 2,
    fill: "url(#door)",
    stroke: "#cfc7b8",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-1 280 280)",
    filter: "url(#paperShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 230,
    width: 200,
    height: 110,
    rx: 2,
    fill: "url(#paper)",
    stroke: "#d4ccbb",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 222,
    width: 34,
    height: 16,
    rx: 2,
    fill: "url(#tape)",
    transform: "rotate(-18 190 230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 222,
    width: 34,
    height: 16,
    rx: 2,
    fill: "url(#tape)",
    transform: "rotate(16 380 230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 332,
    width: 34,
    height: 16,
    rx: 2,
    fill: "url(#tape)",
    transform: "rotate(17 190 340)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 332,
    width: 34,
    height: 16,
    rx: 2,
    fill: "url(#tape)",
    transform: "rotate(-15 380 340)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 280,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#2f2d29"
  }, "\n      Eksamen, shh \uD83E\uDD2B\n    "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 520,
    r: 9,
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 516,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 520,
    r: 4,
    fill: "#404040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.76b8a448cc5108e2f94af0ab58618157.svg";
export { ForwardRef as ReactComponent };